import { Color, theme } from '@/theme.tsx';
import { Loader, Stack, Typography, Box, Grid } from '@components/atoms';
import { Locales } from '@locales/en.ts';
import { useFindRunningChargePointsQuery } from '@services/queries/use-find-running-charge-points.query.ts';
import { Fade } from '@mui/material';
import { EVSECard } from '@components/organisms';
import { CreateVirtualEVSEForm } from '@views/Home/components/CreateVirtualEVSEForm.tsx';

const Home = () => {
  const { data: runningChargePoints, isLoading: isLoadingRunningChargePoints } = useFindRunningChargePointsQuery();

  return (
    <Stack display='flex' direction='row' width={`calc(100vw - ${theme.spacing(8)})`}>
      <Box marginRight={4}>
        <CreateVirtualEVSEForm />
      </Box>
      <Box
        sx={{
          background: Color.Transparent,
          borderRadius: 1,
          marginTop: 0,
          padding: 3,
          flex: 1,
        }}
      >
        {isLoadingRunningChargePoints ? (
          <Loader color='secondary' position='relative' />
        ) : (
          <Grid container spacing={3} columns={12}>
            {(runningChargePoints || []).map(cp => {
              return (
                <Grid key={cp.cpid} item xs={4} md={3} lg={2} sx={{ minWidth: 360 }} zeroMinWidth>
                  <Fade in timeout={400} mountOnEnter unmountOnExit>
                    <div>
                      <EVSECard cp={cp} />
                    </div>
                  </Fade>
                </Grid>
              );
            })}
            {(!runningChargePoints || runningChargePoints.length === 0) && (
              <Grid item xs={12} display='flex' alignItems='center' justifyContent='center'>
                <Typography variant='h5' component='p' color={theme.palette.common.white}>
                  {Locales.homePage.noRunningEVSEs}
                </Typography>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </Stack>
  );
};

export default Home;
